// extracted by mini-css-extract-plugin
module.exports = {"card":"SubregionForecastCard_card__8H0s6","shareIcon":"SubregionForecastCard_shareIcon__qm3hP","actions":"SubregionForecastCard_actions___Wpps"};